import {
  AlignRow,
  IMessageFilteredListProps,
  MessageFilteredList,
} from '@framework/ui';
import { Divider } from 'antd';
import React from 'react';

export interface IAdminMessageFilteredListProps
  extends IMessageFilteredListProps {}

export function AdminMessageFilteredList(
  props: IAdminMessageFilteredListProps,
) {
  const { visible } = props;
  return (
    <div style={{ marginTop: visible ? 6 : 0 }}>
      {visible && <Divider style={{ margin: 0, marginBottom: 6 }} />}
      <AlignRow justify="center">
        <MessageFilteredList {...props} />
      </AlignRow>
    </div>
  );
}
